import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';
import { AuthenticationVerifierService } from './authentication-verifier.service';
import { AuthorizationVerifierService } from './authorization-verifier.service';
import { CookiePolicyAcceptanceVerifierService } from './cookie-policy-acceptance-verifier.service';
import { RoutingDataService } from './routing-data.service';
import { log } from '../angular-common/util'

/**
 * Questa Guard deve essere chiamata prima di qualunque navigazione (privata o pubblica che sia)
 * Prima setta sul RoutingDataService
 * 1. La url di navigazione corrente
 * 2. Il nodo di navigazione corrente (sulla base della url)
 * Poi controlla, nell'ordine, che la navigazione sia lecita per via di:
 * 1. accettazione cookie policies (qualora sia previsto per questa applicazione)
 * 2. avvenuta autenticazione (qualora si tratti di una pagina privata)
 * 3. presenza dei permessi necessari (qualora si tratti di una pagina privata)
 * Se la navigazione è consentita, allora valorizza tutte le altre variabili di navigazione necessarie.
 */
@Injectable()
export class RoutingGuardService implements CanActivate {

  constructor(private _injector: Injector) { }

  /** @override */
  public canActivate(activatedRouteSnapshot:ActivatedRouteSnapshot, routerStateSnapshot:RouterStateSnapshot): Observable<boolean> {
    log('RoutingGuardService', 'canActivate()', 'routerStateSnapshot.url', routerStateSnapshot.url, 'lightGreen', true)
    
    this._injector.get(RoutingDataService).setCurrentUrl(routerStateSnapshot.url);
    this._injector.get(RoutingDataService).setCurrentRoutingNode();
    
    return from(this._check(routerStateSnapshot));
  }

  private async _check(routerStateSnapshot: RouterStateSnapshot):Promise<boolean> {
    let outcome = false;

    outcome = await this._injector.get(CookiePolicyAcceptanceVerifierService).check(routerStateSnapshot);

    if(outcome)
      outcome = await this._injector.get(AuthenticationVerifierService).check(routerStateSnapshot);

    if(outcome)
      outcome = await this._injector.get(AuthorizationVerifierService).check(routerStateSnapshot);
    
    return outcome;
  }
}